module.exports = __webpack_public_path__ + "img/vmc_aniv28_24Aug2021.b7a680f4.jpg";